export default class ECSAttributionCookie {
  // Function to read the cookie data back into the system for Attribution application
  processCookie (_name) {
    const cookieValue = this.readAttributionCookie(_name)
    const cookie = JSON.parse(cookieValue)
    return cookie
  }

  // Function to generate a cookie to track the current marketing lead
  setAttributionCookie (source, exdays) {
    const date = new Date()
    date.setTime(date.getTime() + (exdays * 24 * 60 * 60 * 1000))
    const expires = 'expires=' + date.toUTCString()
    const attributionData = encodeURIComponent(JSON.stringify(source))

    document.cookie = 'ecsattr=' + attributionData + ';' + expires + ';path=/'
  }

  // Delete the cookie if something changes
  destroyAttributionCookie (_name) {
    document.cookie = _name + '=; Max-Age=-99999999;'
  }

  // Parse the cookie
  readAttributionCookie (_name) {
    let name = _name + '='
    let decodedCookie = decodeURIComponent(document.cookie)
    let ca = decodedCookie.split(';')

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) == ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  }

  // Check for the cookie
  checkAttributionCookie (_name) {
    const cookie = this.readAttributionCookie(_name)
    if (cookie !== '') {
      // The cookie is populated
      return true
    } else {
      // The cookie is not populated
      return false
    }
  }
}
